"use client"

import { router, usePage } from "@inertiajs/react"
import type { PropsWithChildren } from "react"

import { NativeSelect } from "@/components/ui/select"
import { TabList, Tabs } from "@/components/ui/tabs"
import { ConsoleLayout } from "@/layouts/console-layout"

const allTabs = [
  { id: "profile", label: "Profile" },
  { id: "password", label: "Password" },
  { id: "email", label: "Email" },
  { id: "sessions", label: "Sessions" },
]

export default function SettingsLayout({ children }: PropsWithChildren) {
  const { url, props } = usePage()
  const { auth } = props
  const tabs = auth?.user?.oauth_user
    ? allTabs.filter((tab) => tab.id !== "password")
    : allTabs

  // Extract the current tab from the URL
  // e.g. /settings/profile -> profile
  const currentTab = url.split("/").pop() || "profile"

  const handleTabChange = (key: React.Key) => {
    router.visit(`/settings/${key}`)
  }

  return (
    <ConsoleLayout>
      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-5 px-4 lg:px-8">
          <div className="flex flex-col gap-1">
            <span className="crumb">account</span>
            <h1 className="text-display-xs text-primary">Settings</h1>
          </div>

          <NativeSelect
            aria-label="Page tabs"
            className="md:hidden"
            value={currentTab}
            onChange={(event) => handleTabChange(event.target.value)}
            options={tabs.map((tab) => ({ label: tab.label, value: tab.id }))}
          />
          <div className="scrollbar-hide -mx-4 -my-1 flex overflow-auto px-4 py-1 lg:-mx-8 lg:px-8">
            <Tabs
              className="hidden md:flex xl:w-full"
              selectedKey={currentTab}
              onSelectionChange={handleTabChange}
            >
              <TabList type="underline" className="w-full" items={tabs} />
            </Tabs>
          </div>
        </div>

        {children}
      </div>
    </ConsoleLayout>
  )
}
